module.exports = __webpack_public_path__ + "static/delivery-service-4b3dc35ca68609701ae26eab71e08dcc.png";